import axios, { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { responsables, responsablesCrear, responsablesEditar } from "../models/responsables";


const mutuosVigentes = async (params: Partial<responsables>) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-maestros/v1/responsables/tiene-mutuo`, {
        params: {
            rut: params.rut,
            idResponsabilidad: params.idResponsabilidad,
          },
        });
    return response;
};

const crearResponsable = async (data: responsablesCrear) => {    
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-maestros/v1/responsables/crear`, data);
    return response;

};

const actualizarResponsable = async (data: responsablesCrear) => {
    const response: AxiosResponse = await axiosInstance.put(`siscred-api-maestros/v1/responsables/actualizar/${data.rut.trim()}`, data);
    return response;
};
export {
    crearResponsable,
    actualizarResponsable,
    mutuosVigentes
}